import React, { useState } from 'react';
import { Element } from 'react-scroll';
import logoImage from './assets/logo.png';

const Hero = () => {
  const [showVideo, setShowVideo] = useState(false);
  return (
    <Element name="home">
      <section
      id = "home"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          backgroundImage: "url('/assets/hero.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          overflow: 'hidden',
          padding: '0 20px',
          fontFamily: 'Roboto',
        }}
      >
        {/* Background overlay */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'white',
            opacity: 0.9,
          }}
        ></div>

        <div
          style={{
            position: 'relative',
            zIndex: 10,
            maxWidth: '1000px',
            width: '100%',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          {/* Logo */}
          <img
            src={logoImage}
            alt="Sevenky Logo"
            style={{
              width: '800px',
              maxWidth: '100%',
              objectFit: 'contain',
              filter: 'brightness(1.0) contrast(1.2)',
            }}
            draggable="false"
            onContextMenu={(e) => e.preventDefault()}
          />

          {/* Title */}
          <h1
            style={{
              fontSize: '28px',
              fontWeight: 'bold',
              backgroundImage: 'linear-gradient(to right, #00008B, rgb(41, 124, 73))',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
              margin: 0,
            }}
          >
            We Aspire to shape Innovative Technologies into Smart Products
          </h1>

          {/* Action Buttons */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '20px',
              marginTop: '20px',
              flexWrap: 'wrap',
            }}
          >
            <a
              href="#about"
              style={{
                background: '#2563eb',
                color: 'white',
                padding: '10px 20px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontSize: '22px',
                fontWeight: 'bold',
                transition: 'background 0.3s',
              }}
              onMouseOver={(e) => (e.currentTarget.style.background = '#1e40af')}
              onMouseOut={(e) => (e.currentTarget.style.background = '#2563eb')}
            >
              Get Started
            </a>

            {!showVideo && (
              <button
                onClick={() => setShowVideo(true)}
                style={{
                  background: 'white',
                  color: '#2563eb',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '22px',
                  fontWeight: 'bold',
                  transition: 'background 0.3s',
                }}
                onMouseOver={(e) => (e.currentTarget.style.background = '#f0f0f0')}
                onMouseOut={(e) => (e.currentTarget.style.background = 'white')}
              >
                Watch Video
              </button>
            )}
          </div>
        </div>

        {/* Fullscreen Video Modal */}
        {showVideo && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2000,
              animation: 'fadeIn 0.3s ease',
            }}
          >
            <div
              style={{
                position: 'relative',
                width: '90%',
                maxWidth: '1000px',
              }}
            >
              <video
                src="/assets/video.mp4"
                controls
                autoPlay
                style={{
                  width: '100%',
                  borderRadius: '10px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                }}
              >
                Your browser does not support the video tag.
              </video>

              {/* Close Video Button */}
              <button
                onClick={() => setShowVideo(false)}
                style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '-10px',
                  background: '#dc2626',
                  color: 'white',
                  padding: '8px 12px',
                  borderRadius: '50%',
                  border: 'none',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                  transition: 'background 0.3s',
                }}
                onMouseOver={(e) => (e.currentTarget.style.background = '#b91c1c')}
                onMouseOut={(e) => (e.currentTarget.style.background = '#dc2626')}
              >
                ✕
              </button>
            </div>
          </div>
        )}
      </section>
    </Element>
  );
};

export default Hero;
